module.exports = __webpack_public_path__ + "static/media/news.f805dedc.jpg";